import { createStore, withProps } from '@ngneat/elf';
import { SelectOption } from '../../components/form-builder/form-builder.types';
import { Address, AddressDto } from '../../types';

export interface AddressStateProps {
  response?: Partial<Address>;
  dto?: Partial<AddressDto>;
  addressTypeSelected?: SelectOption;
}

export const addressInitialState: AddressStateProps = {
  response: {
    id: 0,
    adresse: '',
    codePostal: '',
    ville: '',
    compAdresse: '',
    tel1: '',
    tel2: '',
    pays: {
      id: 0,
      code: '',
      description: '',
    },
    email: '',
    fax: '',
  },
  dto: { address: '', typeId: 0 },
  addressTypeSelected: { name: '', code: 0 },
};

export const addressStateStore = createStore({ name: 'address-state' }, withProps<AddressStateProps>({ ...addressInitialState }));
